import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { useBackgroundChecksRequestQuery } from "../../../query/backgroundChecks/queries/useBackgroundChecksRequestQuery";
import { useInsuranceCoverageMonitorQuery } from "../../../query/insuranceCoverageMonitor/queries/useInsuranceCoverageMonitorQuery";
import { useSharedFileQuery } from "../../../query/sharedFile/query/useSharedFileQuery";
import { useSignedDocumentQuery } from "../../../query/signedDocuments/query/useSignedDocumentQuery";
import { getRequirementDefinitionName } from "../../RequirementDefinitions/utils";

export const usePayeeRequirementNames = (props: {
  requirementType: RequirementType;
  requirementDataSourceId: string;
}) => {
  const { requirementType, requirementDataSourceId } = props;

  const querySignedDocument = useSignedDocumentQuery(requirementDataSourceId, {
    enabled: requirementType === RequirementType.Signature
  });

  const queryBackgroundCheck = useBackgroundChecksRequestQuery(
    requirementDataSourceId,
    {
      enabled: requirementType === RequirementType.BackgroundCheck
    }
  );

  const querySharedFile = useSharedFileQuery(requirementDataSourceId, {
    enabled: requirementType === RequirementType.SharedFile
  });

  const queryInsuranceCoverageMonitor = useInsuranceCoverageMonitorQuery(
    requirementDataSourceId,
    {
      enabled: requirementType === RequirementType.InsuranceCoverage
    }
  );

  const nameByDefinition = getRequirementDefinitionName({
    type: requirementType,
    contextType: querySharedFile.data?.contextType,
    policyType: (queryInsuranceCoverageMonitor.data as any)?.policyType
  });

  const namesMapByDataSource: Record<RequirementType, string | undefined> = {
    [RequirementType.Signature]: querySignedDocument.data?.title,
    [RequirementType.BackgroundCheck]:
      queryBackgroundCheck.data?.settings?.title,
    [RequirementType.SharedFile]: querySharedFile.data?.title,
    [RequirementType.IdentityVerification]: nameByDefinition,
    [RequirementType.InsuranceCoverage]: nameByDefinition,
    [RequirementType.Registration]: nameByDefinition,
    [RequirementType.TaxVerification]: nameByDefinition,
    [RequirementType.PayoutMethod]: nameByDefinition
  };

  const loaders: Record<RequirementType, boolean> = {
    [RequirementType.Signature]: querySignedDocument.isLoading,
    [RequirementType.BackgroundCheck]: queryBackgroundCheck.isLoading,
    [RequirementType.SharedFile]: querySharedFile.isLoading,
    [RequirementType.IdentityVerification]: false,
    [RequirementType.InsuranceCoverage]: false,
    [RequirementType.Registration]: false,
    [RequirementType.TaxVerification]: false,
    [RequirementType.PayoutMethod]: false
  };

  return {
    isLoading: loaders[requirementType],
    name: namesMapByDataSource[requirementType] || nameByDefinition,
    definitionName: nameByDefinition
  };
};
